module.exports = __webpack_public_path__ + "img/poster-pop.7ab5b59f.png";